/** App error. */
export class AppError extends Error {
  constructor(error) {
    super(error.message);
    this.errors = error.errors;
  }
}
